import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import APIS from 'src/common/api';
import mods from './mods';
import PAGE from './page';
import * as utils from "src/store/utils"; 
// const APIS = API.default;

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      adminUserName: '',
    },
    hasLogin: false,
    powerRouterList: [],
    menu: {
      hide: true
    },
    processBar: {
      process: null,
      hide: true
    },
    gloablInfo: {},
    lscmRouterShow: {
      showTscmUserRouter: false,
      showTscmLogicRouter: false,
      showTscmDataRouter: false,
    },
    brandCodeList: [],
    LC_DOMAIN: '',
    LCSCM_UAT_HOST: 'http://tscm-logic.uat.trendy-global.com',
    LCSCM_RPD_HOST: 'https://tscm-logic.trendygroup-it.com',
    newWindowPath: [
      '/production-process',
      '/vendor-apply/declaration-Info/apply'
    ],
    LC_PAGE: false,
    schedulePageList: [],
    LCSCM_UAT_REGISTER_APP_LIST: [
      {
        entry: 'http://tscm-logic.uat.trendy-global.com',
        activeRule: '/lcscm',
        initFlag: 'init_lc_scm',
        container: '#subApp-lcscm-logic'
      },
      {
        entry: 'http://tscm-cost.uat.trendy-global.com',
        activeRule: '/lcscmcost',
        initFlag: 'init_lc_scm_cost',
        container: '#subApp-lcscm-cost'
      },
      {
        entry: 'http://tscm-user.uat.trendy-global.com',
        activeRule: '/lcscmuser',
        initFlag: 'init_lc_scm_user',
        container: '#subApp-lcscm-user'
      },
      {
        entry: 'http://tscm-data.uat.trendy-global.com',
        activeRule: '/lcscmdata',
        initFlag: 'init_lc_scm_data',
        container: '#subApp-lcscm-data'
      },
    ],
    LCSCM_RPD_REGISTER_APP_LIST: [
      {
        entry: 'http://tscm-logic.trendy-global.com',
        activeRule: '/lcscm',
        initFlag: 'init_lc_scm',
        container: '#subApp-lcscm'
      },
      {
        entry: 'http://tscm-cost.trendy-global.com',
        activeRule: '/lcscmcost',
        initFlag: 'init_lc_scm_cost',
        container: '#subApp-lcscm-cost'
      },
      {
        entry: 'http://tscm-user.trendy-global.com',
        activeRule: '/lcscmuser',
        initFlag: 'init_lc_scm_user',
        container: '#subApp-lcscm-user'
      },
      {
        entry: 'http://tscm-data.trendy-global.com',
        activeRule: '/lcscmdata',
        initFlag: 'init_lc_scm_data',
        container: '#subApp-lcscm-data'
      },
    ],
    cacheIframePageList: []
  },
  getters: {
    userName: function(state) {
      return state.userName;
    },
    userId: function(state) {
      return state.userId;
    },
    brandCodeList(state) {
      return state.brandCodeList
    },
    isAdmin(state) {
      return state.userInfo && state.userInfo.adminUserType == 2
    }
  },
  mutations: {
    HIDEMENU(state) {
      state.menu.hide = true
    },
    SHOWMENU(state) {
      state.menu.hide = false
    },
    TOGGLEMENU(state) {
      state.menu.hide = !!!state.menu.hide
    },
    LOGOUT(state) {
      state.hasLogin = false
      state.userInfo = null
    },
    // CLEARPOWER(state) {
    //   state.power = null
    // },
    LOGIN(state, userInfo) {
      window.sessionStorage.userInfo = JSON.stringify(userInfo)
      state.hasLogin = true
      state.userInfo = userInfo
    },
    SAVE_POWER_ROUTER_LIST(state, powerRouterList) {
      state.powerRouterList = powerRouterList
      window.sessionStorage.powerRouterList = JSON.stringify(powerRouterList)
    },
    changeShowTscmUserRouter(state, data) {
      state.lscmRouterShow = data
    },
    setLcDomain(state, url) {
      state.LC_DOMAIN = url
      window.localStorage.setItem(
        "LC_DOMAIN",
        url
      );
    },
    setUserBrandCodeList(state, brandCodeList) {
      state.brandCodeList = brandCodeList
    },
    SETLCPAGE(state, isLcPage) {
      state.LC_PAGE = isLcPage
    },
    SETSCHEDULE(state, list) {
      state.schedulePageList = list || []
      window.sessionStorage.schedulePageList = JSON.stringify(list || [])
    },
    SETOPERATELIST(state, list) {
      window.sessionStorage.operateList = JSON.stringify(list || [])
    },
    SET_CACHE_IFRAME_PAGE(state) {
      state.cacheIframePageList = []
    }
  },
  actions: {
    hideMenu(ctx) {
      ctx.commit('HIDEMENU')
    },
    showMenu(ctx) {
      ctx.commit('SHOWMENU')
    },
    toggleMenu(ctx) {
      ctx.commit('TOGGLEMENU')
    },
    login(ctx, userInfo) {
      ctx.commit('LOGIN', userInfo)
    },
    logout(ctx, userId) {
      ctx.commit('LOGOUT')
      if(userId) {
        APIS.autoAPi.POST_AD_FIND_LOGOUT({userId})
          .done(res => {
            window.sessionStorage.removeItem('userInfo')
            window.sessionStorage.removeItem('timeStamp')
            window.sessionStorage.removeItem('powerRouterList')
            window.sessionStorage.removeItem('schedulePageList')
            window.sessionStorage.removeItem('operateList')
          }).fail(err => {
  
          })
      }
      //window.location.href="//"+window.location.host;
    },
    // clearPower(ctx) {
    //   ctx.commit('CLEARPOWER')
    // },
    savePowerRouterList(ctx, powerRouterList) {
      ctx.commit('SAVE_POWER_ROUTER_LIST', powerRouterList)
    },
    getPowerRouterList(ctx, userId) {
      return new Promise((resolve, reject) => {
        APIS.autoAPi.POST_AD_FIND_LOGIN_USER_RESOURCES({userId})
          .done(resp => {
            let resourceResp = resp.data
            let powerRouterList = []
            let schedulePowerList = []
            if(resourceResp && resourceResp.menuList && resourceResp.menuList.length) {
              powerRouterList.push({
                resIcon: 'fas fa-home',
                resourceName: '首页',
                id: 0,
                resUrl: '/',
                menuType: 0
              })
              // 进度看板显示权限
              let scheduleId = _.find(resourceResp.menuList, item => item.resourceName == '进度看板')
              if(scheduleId) {
                let list = _.filter(resourceResp.menuList, item => item.parentId == scheduleId.id)
                if(list.length) {
                  schedulePowerList = _.map(list, item => item.resourceName)
                }
                ctx.commit('SETSCHEDULE', schedulePowerList)
              }
              _.each(_.orderBy(_.filter(resourceResp.dicList, fitem => fitem.displayFlag != 0 && fitem.resourceName != '进度看板'), ['priority'], ['asc']), menuItem => {
                // console.log('menuItem:', menuItem)
                // if(menuItem.resType == 0) { // 目录
                  powerRouterList.push(menuItem)
                // }
              })
              // let menuGroup = _.groupBy(_.filter(resourceResp.menuList, item => item.resUrl), menuItem => menuItem.parentId) // 根据id分组
              let menuGroup = _.groupBy(_.orderBy(_.filter(resourceResp.menuList, fitem => {
                fitem.resColor = utils.getRandomColor()
                return fitem.displayFlag != 0 && fitem.resourceName != '进度看板'
              }), ['priority'], ['asc']), menuItem => menuItem.parentId) // 根据id分组
                _.each(powerRouterList, parentMenu => { // 根据父id生成子菜单
                  if(menuGroup[parentMenu.id]) {
                    parentMenu.children = menuGroup[parentMenu.id]
                  }
                })
              ctx.commit('SETOPERATELIST', resourceResp.operateList)
            }
            resolve(powerRouterList)
          }).fail(err => {
            ctx.commit('SAVE_POWER_ROUTER_LIST', [])
            reject(false)
          })
      })
    },
  },
  modules: {
    mods,
    PAGE
  }
})
